// hooks/useUploadLora.ts
"use client";

import { useMutation } from "@tanstack/react-query";
import { fetch } from "libs";
import { UPLOAD_LORA } from "api";

interface UploadLoraResponse {
  message: string;
  lora_id: string;
}

interface UploadLoraData {
  file?: File | null
  fileName?: string 
  title: string;
  trigger_words?: string;
  image_url: string;
  download_count: number;
  is_nsfw: boolean;
}

const uploadLora = async (data: UploadLoraData): Promise<UploadLoraResponse> => {
  const formData = new FormData();
  if (data.file) {
    formData.append('file', data.file);
  } else if (data.fileName) {
    formData.append('file_name', data.fileName.trim());
  }
  formData.append('title', data.title);
  if (data.trigger_words) {
    formData.append('trigger_words', data.trigger_words);
  }
  formData.append('image_url', data.image_url);
  formData.append('download_count', data.download_count.toString());
  formData.append('is_nsfw', data.is_nsfw.toString());

  const response = await fetch(UPLOAD_LORA, {
    method: "POST",
    body: formData,
  });
  
  return response;
};

const useUploadLora = () => {
  return useMutation({
    mutationFn: uploadLora,
    onSuccess: (data) => {
      console.log("Lora uploaded successfully", data);
    },
    onError: (error) => {
      console.error("Error uploading Lora:", error);
    },
  });
};

export default useUploadLora;